// Function to remove locale information from the URL path, if it exists.
// Input is expected to be a pathname (e.g. /gb/some/page, /some/page)
export const sanitisePagePath = (url) => {
    if (!url) {
        return null;
    }
    // eslint-disable-next-line unicorn/no-unsafe-regex
    const path = url.replace(/^\/[a-z]{2}(?:-[a-z]{2})?\//i, '/');
    //Remove trailing slash if it's not the root path
    if (path.length > 1 && path.endsWith('/')) {
        return path.slice(0, -1);
    }
    return path;
};
